import { PulseEnvironment } from '@pulse/browser-shared';
import { AnalyticsPlugin, BuiltinEvents } from '@pulse/common';
import { filter } from 'rxjs';
import { ActivityTracker } from '../../services';
export class ClickEventPlugin implements AnalyticsPlugin {
    constructor(
        private activity: ActivityTracker,
        private env: PulseEnvironment,
    ) {}

    init() {
        this.activity
            .interactions()
            .pipe(
                filter(
                    (event) =>
                        event.type === BuiltinEvents.CLICK && !event.doNotTrack && event.clickable,
                ),
            )
            .subscribe((event) => {
                this.env.win.dataLayer?.push({
                    pulse: 'event',
                    event_type: BuiltinEvents.CLICK,
                    data: {
                        click_source: {
                            section: event.section.name,
                            group: event.section.group,
                            popup_component: event.section.popupComponent,
                            popup_component_type: event.section.popupComponentType,
                            element: {
                                id: event.element?.id || event.element?.name,
                                name: event.element?.name,
                                node_type: event.element?.nodeName,
                                class_list: event.element?.classList,
                            },
                        },
                        additional_properties: event?.additionalProperties,
                    },
                });
            });
    }
}
